export function useDataLoading({
  getterName,
  paged = true,
  dataParams = [],
  ignoredParams = [],
  ignoredQueryItems = [],
  contentName = '',
  queryable = true,
  searchable = true,
  parameterize = false,
}) {
  return {
    data: () => ({
      isLoading: false,
      loadingError: { show: false, msg: '' },
      allowGettingData: true,
    }),
    computed: {
      noContent() {
        return {
          show: contentName ? this[contentName].length < 1 : false,
          msg: 'No content',
        };
      },
    },
    watch: {
      allowGettingData: {
        handler(newValue) {
          if (!newValue) {
            return;
          }
          this.$nextTick(async () => {
            try {
              await this.getData();
            } finally {
              this.allowGettingData = false;
            }
          });
        },
        immediate: true,
      },
      '$route.params': {
        handler(newValue, oldValue) {
          if (
            parameterize
            && this.$_checkAllowRefreshByValues(newValue, oldValue, ignoredParams)
          ) {
            this.$_fetchData();
          }
        },
        deep: true,
      },
      '$route.query': {
        handler(newValue, oldValue) {
          if (
            queryable
            && this.$_checkAllowRefreshByValues(newValue, oldValue, ignoredQueryItems)
          ) {
            this.$_fetchData();
          }
        },
        deep: true,
      },
    },
    methods: {
      async getData() {
        const response = { ...this.$route.query };
        const paramsResponse = { ...this.$route.params };

        ignoredQueryItems.forEach((ignored) => delete response[ignored]);
        ignoredParams.forEach((ignored) => delete paramsResponse[ignored]);

        if (searchable) {
          Object.assign(response, {
            ...response,
            ...this.parseSearchData(this.searchData),
          });
        }

        if (parameterize) {
          Object.assign(response, {
            ...response,
            ...paramsResponse,
          });
        }

        if (paged) {
          response.pageNum = response.pageNum || 1;
        }

        dataParams.forEach((param) => {
          response[param] = this[param];
        });

        this.$_showLoading();
        this.$_setLoadingError({ show: false });

        try {
          await this[getterName](response);
          return Promise.resolve();
        } catch (e) {
          this.$_setLoadingError(e);
          return Promise.reject();
        } finally {
          this.$_hideLoading();
        }
      },
      $_checkAllowRefreshByValues(newValue, oldValue, ignored) {
        if (!ignored || !ignored.length) {
          return true;
        }

        const keys = [...new Set([
          ...Object.keys(newValue),
          ...Object.keys(oldValue),
        ])];

        return keys
          .some((k) => {
            if (ignored.includes(k)) {
              return false;
            }
            return newValue[k] !== oldValue[k];
          });
      },
      $_fetchData() {
        this.allowGettingData = true;
      },
      $_refreshData() {
        if (this.$_resetSearch) {
          this.$_resetSearch();
        } else if (this.$_setPage && Number(this.pageNum) !== 1) {
          this.$_setPage('1');
        }
        this.$_fetchData();
      },
      $_showLoading() {
        this.isLoading = true;
      },
      $_hideLoading() {
        this.isLoading = false;
      },
      $_setLoadingError({ show = true, msg = '' }) {
        Object.assign(this, { loadingError: { show, msg } });
      },
    },
  };
}
